module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hot-loader/index.js
// module id = 193
// module chunks = 1